import { render } from "./FormTrainingItemIndicator.vue?vue&type=template&id=56f2d9fa&scoped=true&ts=true"
import script from "./FormTrainingItemIndicator.vue?vue&type=script&lang=ts"
export * from "./FormTrainingItemIndicator.vue?vue&type=script&lang=ts"

import "./FormTrainingItemIndicator.vue?vue&type=style&index=0&id=56f2d9fa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56f2d9fa"]])

export default __exports__